import { ChevronRight } from '@patrianna-icons/material-icons'
import cn from 'classnames'
import Link from 'next/link'

import classes from './styles.module.scss'

type Props = {
  title: string
  url?: string
  count?: number
  iconImg?: string
  isProviders?: boolean
  with3DImage?: boolean
  onClick?: () => void
}

export default function GameRowHeader({ title, iconImg, url, isProviders, with3DImage, onClick }: Props) {
  return (
    <div className={cn(classes.root, with3DImage && classes.root3D)}>
      <h3 className={cn(classes.titleWithLink, isProviders && classes.isProviders)} data-test={`title-${title}`}>
        {iconImg ? (
          <div className={classes.iconWrapper}>
            <img
              src={`${process.env.IMG_ORIGIN}/swimlane-icons/light-theme/${iconImg}`}
              alt={`icon-${title}`}
              className={cn(classes.icon, classes.lightIcon)}
              height={21}
              width={21}
            />
            <img
              src={`${process.env.IMG_ORIGIN}/swimlane-icons/dark-theme/${iconImg}`}
              alt={`icon-${title}`}
              className={cn(classes.icon, classes.darkIcon)}
              height={21}
              width={21}
            />
          </div>
        ) : (
          <div className='h-[21px] w-[21px] mr-[0.3rem]' />
        )}
        <span>{title}</span>
      </h3>

      {url && (
        <Link href={url} prefetch={false}>
          <p className={classes.link} data-test={`show-all-${title}`} onClick={onClick}>
            Show all <ChevronRight className={classes.linkArrow} />
          </p>
        </Link>
      )}
    </div>
  )
}
